import initHeader from "./layout/header.js";

jQuery(document).ready(function ($) {
  initHeader();

  /* Single product gallery  */
  $(".gallery-thumbnail").on("click", function () {
    let fullImageUrl = $(this).attr("data-full");

    $("#mainProductImage").attr("src", fullImageUrl);

    $("#mainProductImage").parent("a").attr("href", fullImageUrl);

    $(".gallery-thumbnail").removeClass("active");
    $(this).addClass("active");
  });
  /* End */

  /* FAQs hide/show */
  $(".faqs__answer").hide();

  $(".faqs__question").on("click", function () {
    var answer = $(this).next(".faqs__answer");

    answer.slideToggle();

    $(this).toggleClass("active");
  });
  /* End */

  /* Quantity - + buttons */
  $(document).on(
    "click",
    ".single-product-section__qty-button.plus",
    function () {
      var $input = $(this).closest(".quantity").find(".qty");
      var currentVal = parseInt($input.val(), 10) || 1;
      var maxVal = parseInt($input.attr("max"), 10) || 99999;

      if (currentVal < maxVal) {
        $input.val(currentVal + 1).trigger("change");
      }
    }
  );

  $(document).on(
    "click",
    ".single-product-section__qty-button.minus",
    function () {
      var $input = $(this).closest(".quantity").find(".qty");
      var currentVal = parseInt($input.val(), 10) || 1;

      if (currentVal > 1) {
        $input.val(currentVal - 1).trigger("change");
      }
    }
  );
  /* End */

  /* Mobile navigation */
  const $menuToggle = $(".mobile-menu-toggle");
  const $mobileNav = $(".mobile-nav");
  const $closeButton = $(".mobile-menu-close");

  function toggleMenu() {
    $mobileNav.toggleClass("active");
    $menuToggle.toggleClass("active");
  }

  $menuToggle.on("click", toggleMenu);
  $closeButton.on("click", toggleMenu);
  /* End */

  // Close menu when clicking outside
  $(document).on("click", function (event) {
    if (
      !$mobileNav.is(event.target) &&
      !$mobileNav.has(event.target).length &&
      !$menuToggle.is(event.target) &&
      !$menuToggle.has(event.target).length
    ) {
      $mobileNav.removeClass("active");
      $menuToggle.removeClass("active");
    }
  });

  // Use a timeout or MutationObserver to wait for blocks to render
  setTimeout(() => {
    const selectors = [
      '[name="billing_address_1"]',
      '[name="billing_city"]',
      '[name="billing_state"]',
      '[name="billing_postcode"]',
      '[name="billing_country"]',
    ];

    selectors.forEach((selector) => {
      const field = document.querySelector(selector);
      if (field) {
        const fieldWrapper = field.closest(".wc-block-components-field");
        if (fieldWrapper) {
          fieldWrapper.style.display = "none";
        }
      }
    });
  }, 500);
  // Delay to make sure fields are rendered

  //Default expanded coupon
  const lang = document.documentElement.lang;

  const observer = new MutationObserver(() => {
    const couponBlock = document.querySelector(
      ".wc-block-components-totals-coupon"
    );
    const toggleButton = couponBlock?.querySelector(
      ".wc-block-components-panel__button"
    );
    const panel = couponBlock?.querySelector(
      ".wc-block-components-panel__content"
    );
    const label = couponBlock?.querySelector("label");

    if (!couponBlock || !toggleButton || !panel) return;

    toggleButton.setAttribute("aria-expanded", "true");
    panel.style.display = "block";
    panel.hidden = false;

    if (lang === "lt-LT" && label) {
      label.textContent = "Įveskite nuolaidos kodą";
    }

    window.scrollTo(0, 0);

    observer.disconnect();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
  // End default coupon
});
